import React from "react";
import { BeatLoader } from "react-spinners";

import logoh from "../../assets/logoh.png";

export default class SpinnerModal extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
          <>
            <div className="newspiner">
              <main className="mainspinners">
                <img className="lagospiner" src={logoh} alt="" />

                <div>
                  <BeatLoader
                    color="#ffffff"
                    loading={this.props.show}
                    css="display: block; margin:auto; fontWeight:bold; "
                    margin={9}
                    size={25}
                    speedMultiplier={0.8}
                  />
                </div>
              </main>
            </div>

            {/*<div className={(this.props.tipo=='full')?("progreso-spinner-full"): "progreso-spinner"}>
                    <div className="animacion-spinner">
                        <DotLoader

                            color={"#ffffff"}
                            size={60}
                            speedMultiplier={1}
                            loading={this.props.show}
                            css="display: block; margin:auto; fontWeight:bold; "
                            aria-label = "loading"      
                       >
                          <span className='sr-only'>Generating report</span>
                       </DotLoader>
                       
                    </div>
                </div>*/}
          </>
        );
    }
}